import { PracticeSessionResult } from '@/types/exam';

interface ProgressBarProps {
  current: number;
  total: number;
  results: PracticeSessionResult[];
}

export function ProgressBar({ current, total, results }: ProgressBarProps) {
  const progress = total > 0 ? ((current + 1) / total) * 100 : 0;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-xs text-fg-subtle">
          Question {current + 1} sur {total}
        </span>
        <span className="text-xs text-fg-faint">
          {Math.round(progress)}%
        </span>
      </div>

      <div className="h-1.5 bg-overlay-2 rounded-full overflow-hidden">
        <div
          className="h-full bg-green-500 rounded-full transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="flex gap-1">
        {Array.from({ length: total }, (_, i) => {
          const result = results[i];
          let color = 'bg-overlay-3';
          if (i === current) color = 'bg-overlay-3 ring-1 ring-line';
          else if (result?.isCorrect) color = 'bg-green-500';
          else if (result && !result.isCorrect) color = 'bg-red-500';

          return (
            <div
              key={i}
              className={`h-1 flex-1 rounded-full ${color} transition-colors duration-200`}
            />
          );
        })}
      </div>
    </div>
  );
}
